import { ButtonPrimary, EmptyState, ErrorFeedbackScreen, IconCallLandlineRegular, skinVars } from '@telefonica/mistica';
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import DetailConsumption from '../../../components/DetailConsumption';
import DetailsConsumptionHeader from '../../../components/DetailsConsumptionHeader';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import './index.scss';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import useUserlight from '../../../utils/hooks/useUserLight';
import SnackbarMessage from '../../../components/SnackbarMessage';
import { getPhoneById } from '../../../utils/dataTransformation/productConsumption';
import { useSearchParams } from 'react-router-dom';
import Stopper from '../../../components/Stopper';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';

const Details: React.FC = () => {
    const isLight = useUserlight();
    const [params] = useSearchParams();
    const { trackingScreenView } = new TrackingEvents();
    const [error, setError] = useState<boolean>(false);
    const { t } = useTranslation();
    const storage = localStorage.getItem('storage');
    const storages = localStorage.getItem('storages');
    const [currentPage, setCurrentPage] = useState(1);
    let storageJson: any;
    let cycleEnded: any;
    const number = window.localStorage.getItem('mc-number');
    const numberUrl = getPhoneById(JSON.parse(storages!), params.get('productPsId')!);
    const homeDisabled = managementEnvironment().REACT_APP_STOPPER_HOME_DISABLED;

    if (storage) {
        storageJson = JSON.parse(storage);
        cycleEnded = storageJson.cycleEnded;
    }

    const [activeView, setActiveView] = useState(storageJson.detailType ?? 'VOICE');
    const setPage = (page: any) => {
        setError(false);
        setCurrentPage(page);
    };
    const reftiemout = useRef<number>(0);
    const firstLoad = useRef<boolean>(true);

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }

        () => {
            clearTimeout(reftiemout.current);
            firstLoad.current = true;
        };
    }, []);

    const manageError = (ev: string) => {
        const state = typeof ev === 'string';
        setError(state ? true : false);
    };

    if (isLight && number !== numberUrl) {
        return <SnackbarMessage url='/home' timeout={3000} />;
    }

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <div className='details-page'>
            <DetailsConsumptionHeader
                setView={setActiveView}
                activeView={activeView}
                dataDetail={storageJson}
                setPage={setPage}
                setError={manageError}
            ></DetailsConsumptionHeader>
            {cycleEnded ? (
                <div className='details-page__emptyStateCycle'>
                    <EmptyState
                        title={t('titleCycleEndedEmptyState')}
                        description={t('descriptionCycleEndedEmptyState')}
                        icon={
                            <IconCallLandlineRegular size={64} color={skinVars.colors.brand}></IconCallLandlineRegular>
                        }
                    ></EmptyState>
                </div>
            ) : (
                <div className='details-page__consumptionContent'>
                    {!error ? (
                        <DetailConsumption activeView={activeView} page={currentPage}></DetailConsumption>
                    ) : (
                        <div className='error-generic-error'>
                            <ErrorFeedbackScreen
                                title={t('supportErrorProblemsTitle')}
                                description={t('supportErrorFeedbackFailedDescription')}
                                primaryButton={
                                    <ButtonPrimary
                                        onPress={() => {
                                            window.location.reload();
                                        }}
                                    >
                                        {t('refresh')}
                                    </ButtonPrimary>
                                }
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Details;
